export default __webpack_public_path__ + "static/media/element_39.fb0206cd.webp";